import { call, put, takeEvery } from 'redux-saga/effects'

import { GET_CALCULATION_REQUESTED } from '../actions/actionTypes'
import { requestForCalculationFailed, requestForCalculationSuccess } from '../actions/quickCalculationAction'
import { cashBoxService } from '../../services/cashbox-service'
import { messages } from '../../helpers/messages'

const getCalculationResults = async (payload) => {
  return await cashBoxService.calculate(payload)
    .then(resp => resp.data)
    .catch((error) => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })
}

function* fetchGetCalculation({ payload }) {
  try {
    const contractCalculations = yield call(getCalculationResults, payload)

    yield put(requestForCalculationSuccess(contractCalculations))
  } catch (error) {
    yield put(requestForCalculationFailed(error))
  }
}

function* getCalculationSaga() {
  yield takeEvery(GET_CALCULATION_REQUESTED, fetchGetCalculation)
}

export {
  getCalculationSaga
}
